const ACCESS_TOKEN_NAME = 'evincedAccessToken';
const ID_TOKEN_NAME = 'evincedIdToken';

export function getFromLocalStorage(key: string): string {
	return localStorage.getItem(key);
}

export function saveToLocalStorage(key: string, value): void {
	localStorage.setItem(key, value);
}

export function getAccessTokenFromLocalStorage(): string {
	return localStorage.getItem(ACCESS_TOKEN_NAME);
}

export function setAccessToken(token): void {
	localStorage.setItem(ACCESS_TOKEN_NAME, token);
}

export function getIdTokenFromLocalStorage(): string {
	return localStorage.getItem(ID_TOKEN_NAME);
}

export function setIdToken(token): void {
	localStorage.setItem(ID_TOKEN_NAME, token);
}

export function removeAuthenticationTokens(): void {
	localStorage.removeItem(ACCESS_TOKEN_NAME);
	localStorage.removeItem(ID_TOKEN_NAME);
}

export function removeValuesOnLogout(): void {
	removeAuthenticationTokens();
}
